import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Users, Shield, User } from 'lucide-react'
import UserManagement from './UserManagement'
import SimpleRoleManagement from './SimpleRoleManagement'

interface TabbedUserRoleManagementProps {
  onUserSelect?: (user: any) => void
  onUsersChange?: (users: any[]) => void
  showMessage?: (message: string, type?: 'success' | 'error' | 'warning' | 'info') => void
  showConfirm?: (message: string) => Promise<boolean>
}

const TabbedUserRoleManagement: React.FC<TabbedUserRoleManagementProps> = ({
  onUserSelect,
  onUsersChange,
  showMessage,
  showConfirm
}) => {
  const { t } = useTranslation()
  const [activeTab, setActiveTab] = useState<'users' | 'roles'>('users')

  return (
    <div className="h-full flex flex-col bg-white">
      {/* Tab Header */}
      <div className="border-b border-gray-200 bg-white flex-shrink-0">
        <div className="flex">
          <button
            onClick={() => setActiveTab('users')}
            className={`flex items-center space-x-2 px-6 py-4 text-sm font-medium border-b-2 transition-colors ${
              activeTab === 'users'
                ? 'border-blue-500 text-blue-600 bg-blue-50'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50'
            }`}
          >
            <Users size={16} />
            <span>{t('user_management')}</span>
          </button>
          
          <button
            onClick={() => setActiveTab('roles')}
            className={`flex items-center space-x-2 px-6 py-4 text-sm font-medium border-b-2 transition-colors ${
              activeTab === 'roles'
                ? 'border-orange-500 text-orange-600 bg-orange-50'
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:bg-gray-50'
            }`}
          >
            <Shield size={16} />
            <span>{t('role_management')}</span>
          </button>
        </div>
      </div>

      {/* Tab Content */}
      <div className="flex-1 min-h-0 overflow-hidden">
        {activeTab === 'users' && (
          <UserManagement
            onUserSelect={onUserSelect}
            onUsersChange={onUsersChange}
            showMessage={showMessage}
            showConfirm={showConfirm}
          />
        )}
        
        {activeTab === 'roles' && (
          <SimpleRoleManagement
            showMessage={showMessage}
          />
        )}
      </div>
    </div>
  )
}

export default TabbedUserRoleManagement
